<script setup>
import { ref, computed, watch } from 'vue'
import axios from 'axios'
import { baseUrl } from '../env'
import { DateTime } from 'luxon'

const aiInput = ref('')
const searchResults = ref([])
const aiLoading = ref(false)
const error = ref(null)
const aiSearched = ref(false);



const headers = [
  { key: 'id', label: 'Конкурс' },
  { key: 'name', label: 'Јединица' },
  // { key: 'township_id', label: 'Јединица' },
  // { key: 'calendar', label: 'Датум' },
  { key: 'competition_published', label: 'Конкурс објављен' },
  { key: 'competition_name', label: 'Назив конкурса' },
  { key: 'media_name0', label: 'Назив медија' },
  // { key: 'upload_competition', label: 'Отпремљен конкурс' },
  // { key: 'upload_competition1', label: 'Отпремљен конкурс 1' },
  // { key: 'solution_date', label: 'Датум решења' },
  // { key: 'upload_accepted_remarks', label: 'Отпремљени прихваћени коментари' },
  // { key: 'whynot_accepted', label: 'Зашто није прихваћено' },
  // { key: 'honorarium_value', label: 'Вредност хонорара' },
  { key: 'date_money', label: 'Датум исплате' },
  // { key: 'upload_decision', label: 'Отпремљена одлука' },
  { key: 'total_money', label: 'Укупно средстава' },
  { key: 'money_allocated', label: 'Додељена средства' },
  { key: 'remain_money', label: 'Преостала средства' },
  { key: 'project_total', label: 'Укупно пројеката' },
  { key: 'granted_projects', label: 'Одобрени пројекти' },
  { key: 'reasons1', label: 'Разлог зашто конкурс није регуларан' },
  // { key: 'rejected_why', label: 'Разлог одбијања' },
  { key: 'remarks_area', label: 'Област примедби' },
  { key: 'notices', label: 'Напомене' },
  // { key: 'report_1', label: 'Извештај 1' },
  // { key: 'report_2', label: 'Извештај 2' },
  // { key: 'report_3', label: 'Извештај 3' },
  // { key: 'contest_not_announced_date', label: 'Датум неодржаног конкурса' },
  // { key: 'commission_members_indexed', label: 'Предложени чланови комисије' },
  { key: 'commission_members_chosen_indexed', label: 'Именовани чланови комисије' },
  { key: 'projects_indexed', label: 'Пројекти' },
  { key: 'medias_indexed', label: 'Медији' },
  { key: 'projectssubmitters_indexed', label: 'Подносиоци пројеката' }

];


const sortKey = ref('calendar')
const sortOrder = ref('desc')

const props = defineProps({
  searchTrigger: Number, // Parent increments this to trigger search
  searchQuery: String    // Parent passes the query text
});

// 🔹 Whenever the parent changes searchTrigger, run performSearch
watch(() => props.searchTrigger, async () => {
  if (!props.searchQuery) return
  aiInput.value = props.searchQuery
  await performSearch()
});

function sortBy(key) {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc'
  } else {
    sortKey.value = key
    sortOrder.value = 'asc'
  }
}

function parseDate(str) {
  if (!str) return new Date(0)
  const [day, month, year] = str.split('.')
  return new Date(`${year}-${month}-${day}`)
}

function formatDateFront(dateStr) {
  if (!dateStr) return '';
  return DateTime.fromISO(dateStr)
    .setZone('Europe/Belgrade')
    .toFormat('dd.MM.yyyy');
}

const sortedResults = computed(() => {
  if (!sortKey.value) return searchResults.value

  return [...searchResults.value].sort((a, b) => {
    let valA = a[sortKey.value] ?? ''
    let valB = b[sortKey.value] ?? ''

    if (sortKey.value === 'calendar') {
      const dateA = parseDate(valA)
      const dateB = parseDate(valB)
      return sortOrder.value === 'asc' ? dateA - dateB : dateB - dateA
    }

    if (typeof valA === 'number' && typeof valB === 'number') {
      return sortOrder.value === 'asc' ? valA - valB : valB - valA
    }

    return sortOrder.value === 'asc'
      ? String(valA).localeCompare(String(valB))
      : String(valB).localeCompare(String(valA))
  })
})

async function fetch(url) {
  const res = await axios.get(`${baseUrl}${url}`)
  const data = res.data
  return (typeof data === 'object' && data !== null) ? data : []
}

async function performSearch() {
  aiLoading.value = true
  error.value = null
  aiSearched.value = true

  try {
    const response = await fetch(`/brain/search?q=${encodeURIComponent(aiInput.value)}`)
    searchResults.value = response || []
  } catch (err) {
    error.value = 'Дошло је до грешке при претрази. Покушајте поново.'
    console.error('Грешка при претрази:', err)
  } finally {
    aiLoading.value = false
  }
}
</script>


<template>
  <div class="table-wrap">
    <!-- <input v-model="aiInput" placeholder="Унесите текст за претрагу" />
    <button @click="performSearch" :disabled="aiLoading">
      {{ aiLoading ? 'Претрага у току...' : 'Претражи 🧠' }}
    </button> -->

    <div v-if="aiLoading">Претрага у току...</div>
    <div v-if="error" style="color:red;">{{ error }}</div>
    <div v-if="searchResults.length > 0" class="table table-bordered sortable-table search-results-header">
      <div class="give-breath">
        <h2>Резултати АИ Претраге по жељеним речима</h2>
      </div>
      <h3>Резултата: {{ searchResults.length }} </h3>
      <button class="clear-results-btn" @click="searchResults = []" title="Сакри резултате">
        ✕
      </button>
    </div>
    <table v-if="searchResults.length > 0" class="table table-bordered sortable-table  sticky-header">
      <thead>
        <tr>
          <th v-for="header in headers" :key="header.key" @click="sortBy(header.key)">
            {{ header.label }}
            <span v-if="sortKey === header.key">
              {{ sortOrder === 'asc' ? '▲' : '▼' }}
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in sortedResults" :key="item.id">
          <td v-for="header in headers" :key="header.key">
            <template v-if="header.key === 'id'">
              <router-link :to="`/konkurs/${item.id}#t`">{{ item.calendar }}</router-link>
            </template>
            <template v-else-if="header.key === 'name'">
              <router-link :to="`/?jedinica=${item.township_id}#t`">{{ item.name }}</router-link>
            </template>
            <template v-else-if="header.key === 'date_money'">
              {{ formatDateFront(item[header.key]) }}
            </template>
            <template
              v-else-if="['report_1', 'report_2', 'report_3', 'upload_competition', 'upload_last_decision', 'upload_competition1', 'upload_decision'].includes(header.key)">
              <template v-if="item[header.key] && item[header.key] !== 'Nema podataka'">
                <a :href="`https://admin.finansiranjemedija.rs/files/${item[header.key]}`" target="_blank"
                  rel="noopener noreferrer" download>
                  {{ item[header.key] }}
                </a>
              </template>
              <template v-else>
                <span>nema podataka</span>
              </template>
            </template>
            <template v-else>
              {{ item[header.key] }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-else-if="aiSearched && searchResults && searchResults.length === 0 && !aiLoading">Нема резултата.</div>


  </div>
</template>

<style scoped>
.sortable-table {
  width: 100%;
  border-collapse: collapse;
}

.sortable-table th,
.sortable-table td {
  border: 1px solid #ccc;
  padding: 0.5rem;
  text-align: left;
}

.sortable-table th {
  cursor: pointer;
  background-color: #f9f9f9;
}

.sortable-table tr:nth-child(even) {
  background-color: #efefef;
  /* light gray or any color you want */
}

/* Container for results header with button */
.search-results-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

/* Clear / hide button */
.clear-results-btn {
  background: rgba(0, 0, 0, 0.05);
  /* subtle neutral background */
  color: var(--csGray);
  border: none;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.clear-results-btn:hover {
  background: rgba(0, 0, 0, 0.15);
  /* slightly darker hover */
  color: var(--csRed);
  /* highlight danger color */
  transform: scale(1.1);
}
</style>
